import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { getCsrfToken } from '../../../libs/csrfToken';

type Props = {
  isModalOpen: boolean;
  redirectUrl: string;
  isLoginError?: boolean;
  flashMessage?: string;
  fromButton: string;
  handleToggleLoginModal: () => void;
  handleChangeModal: () => void;
  handleOauthsLinkClick: (type: string) => void;
  handleFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  lineIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({
  isModalOpen,
  redirectUrl,
  isLoginError,
  flashMessage,
  fromButton,
  handleToggleLoginModal,
  handleChangeModal,
  handleOauthsLinkClick,
  handleFormSubmit,
  lineIcon,
}) => {
  if (!isModalOpen) return null;

  return (
    <div className={classnames('l-login-modal', { 'is-active': isModalOpen })} id="jsx-login-modal">
      <div
        className="l-login-modal-clickarea"
        onClick={handleToggleLoginModal}
      />
      <div className="login-modal gtm-popup-view-count" data-event-name='popup on screen' data-category='login_popup' data-value='login'>
        <div className="login-modal-container">
          <span className="login-modal-heading">ログイン</span>

          <div className="login-modal-inner">
            <ul className="login-modal-button-list">
              <li className="login-modal-button-item">
                <button
                  type="button"
                  className="login-modal-button-link"
                  onClick={() => handleOauthsLinkClick('line')}
                  data-event='click'
                  data-category='login_popup'
                  data-value='line'
                />
                <div className="login-modal-button-item-box login-modal-button-item-line btn">
                  <div className="login-modal-button-item-box-inner img">
                    <img
                      src={lineIcon}
                      alt="LINEログイン"
                      className="login-modal-button-item-box-inner-icon line"
                    />
                    <p className="login-modal-button-item-box-inner-text">LINE でログイン</p>
                  </div>
                </div>
              </li>
              <li className="login-modal-button-item">
                <button
                  type="button"
                  className="login-modal-button-link"
                  onClick={() => handleOauthsLinkClick('apple')}
                  data-event='click'
                  data-category='login_popup'
                  data-value='apple'
                />
                <div className="login-modal-button-item-box login-modal-button-item-apple btn">
                  <div className="login-modal-button-item-box-inner">
                    <i className="fab fa-apple login-modal-button-item-box-inner-icon" />
                    <p className="login-modal-button-item-box-inner-text">Apple でログイン</p>
                  </div>
                </div>
              </li>
            </ul>

            <div className="login-modal-sns">
              <a
                className="login-modal-sns-link"
                href="/password_resets/fetch_password_social"
                data-event='click'
                data-category='login_popup'
                data-value='sns'
              >
                SNSでログイン
              </a>
            </div>

            <p className="login-modal-gray">もしくは</p>

            {isLoginError &&
              <div className="js-user-login-alert">
                <div className="alert alert-danger">
                  <p>{flashMessage}</p>
                </div>
              </div>
            }

            <div className="login-modal-form">
              <form action="/hr_login/create" method="post" className="login-modal-form" onSubmit={handleFormSubmit}>
                <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
                <div className="login-modal-form-input">
                  <div className="login-modal-form-mail">
                    <input type="text" name="email" placeholder="メールアドレス" />
                  </div>
                  <div className="login-modal-form-pass">
                    <input type="password" name="password" placeholder="パスワード" />
                  </div>
                  <input type="hidden" name="redirect_url" value={redirectUrl} />
                </div>
                <div className="login-modal-form-submit">
                  <input type="submit" value="ログイン" className={classnames('btn', `from_${fromButton}` )} data-event='click' data-category='login_popup' data-value='login'/>
                </div>
              </form>
              <a
                className="login-modal-form-reset"
                href="/password_resets/new"
                data-event='click'
                data-category='login_popup'
                data-value='to_reset_password'>
                  パスワードを忘れた方はこちら
              </a>
            </div>
            <p className="login-modal-gray">その他</p>
            <div className="login-modal-others">
              <a className="register" href="/hr_login/new" data-event='click' data-category='login_popup' data-value='to_company_login'>企業ログインはこちら</a>
              <a onClick={handleChangeModal} className="right" data-event='click' data-category='login_popup' data-value='to_register'>新規登録はこちら</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
